import { RefObject, useMemo, useRef } from 'react';

export interface ProgrammaticScrollGuard {
  /** True while a programmatic scroll's events may still be in flight. */
  isSuppressedRef: RefObject<boolean>;
  run(scroll: () => void): void;
}

/*
  Lets the thread's scroll consumers (pagination, new-messages boundary, prepend lock)
  tell a scrollTop the app wrote itself apart from one the reader produced.
*/
export function useProgrammaticScrollGuard(): ProgrammaticScrollGuard {
  const isSuppressedRef = useRef(false);

  return useMemo(
    () => ({
      isSuppressedRef,
      run: (scroll) => {
        isSuppressedRef.current = true;
        scroll();
        // The native 'scroll' event dispatches asynchronously — clear the guard only once it
        // has had a chance to fire, or real user scrolling gets swallowed.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            isSuppressedRef.current = false;
          });
        });
      },
    }),
    [],
  );
}
